import React from 'react';
import { Col, Row } from 'react-bootstrap';
import styleClasses from '../try2.module.scss';
import { verifyStatus } from '../../../helpers/customizedItem/customizedItem.helper';
import * as Constant from '../../../constants';
import CounterCard from '../../../components/Molecules/Card/CounterCard/CounterCard';

interface Param {
  modifier_id: number;
  modifier_name: string;
  display_price: number;
  brink_id: number;
  quantity?: number;
  modifier_group_id: number;
  brink_modifier_group_id: number;
  modifier_group_max?: number;
  plusminus?: string;
}

interface IAddOns {
  title: string;
  items_count: any;
  itemNo: number;
  isSingleItemCustomization?: boolean;
  compli_title_size?: string;
  ingredients: {
    extendable_limit: number;
    id: number;
    brink_modifier_id: number;
    name: string;
    price: number;
    image: string;
    calories: number;
    max: number;
    changes: any;
    items_count: string;
    compli_title_size?: string;
    is_selected: number;
    modifier_location: {
      status: string | null;
    }[];
  }[];
  selectedIngredients: {
    additionalPrice?: number;
    modifier_id: number;
    quantity: number;
  }[];
  handleClick: (args: Param) => void;
  isLimitExceed?: boolean;
  modifierGroup: {
    id: number;
    brink_modifier_group_id: number;
    max?: number;
  };
  FullSize?: string;
  isItEdit?: boolean;
  order?: any;
  contentCenter?: string;
}

const AddOns: React.FC<IAddOns> = (props) => {
  const {
    title,
    ingredients,
    selectedIngredients,
    handleClick,
    modifierGroup,
    isLimitExceed,
    items_count,
    compli_title_size,
    isSingleItemCustomization,
    FullSize,
    isItEdit,
    contentCenter
  } = props;

  const handleIngredientSelection = (data, ingredient) => {
    handleClick({
      ...data,
      ...{
        modifier_group_id: modifierGroup?.id,
        modifier_group_max: modifierGroup?.max,
        modifier_type:Constant.COMPLIMENTARY_MODIFIER,
        brink_modifier_group_id: modifierGroup?.brink_modifier_group_id,
        complimentary_modifier: ingredient?.complimentary_modifier,
      },
    });
  };

  const selectedIngredient = (ingredient: any) => {
    return selectedIngredients?.find(
      (selected) => selected.modifier_id === ingredient.id
    );
  };

  const counterCard = (ingredient, selectedSide) => {
    return (
      <CounterCard
        id={ingredient.id}
        brink_id={ingredient.brink_modifier_id}
        image={`${Constant.REACT_APP_CLOUD_FRONT}${ingredient.image}`}
        title={ingredient.name}
        default_selected={ingredient.is_selected}
        calories={ingredient.calories}
        price={ingredient.price}
        is_active={verifyStatus(ingredient, Constant.MODIFIER_LOCATION)}
        handleClick={(data) => handleIngredientSelection(data, ingredient)}
        max={ingredient.max}
        count={selectedSide?.quantity || 0}
        additionalPrice={selectedSide?.additionalPrice}
        priceAlternateLabel={selectedSide ? 'Included' : 'include'}
        from={Constant.TRY_2_COMBO}
        // isAddByDefault={isAddByDefault()}
        extendableLimit={isLimitExceed}
        isItEdit={isItEdit}
        lastCardHideClass={styleClasses.item_wrap_card_hide}
      />
    );
  };
 

  return (
    <>
      {isSingleItemCustomization ? (
        <div className="Complimentary_sides-view">
          <h5
            className={`${
              compli_title_size ? compli_title_size : 'f-s20 f-sm-s18 text-capitalize'
            } lh-normal font-Cls text-start mb-md-3 pt-2 pt-md-3`}
          >
            {title}
          </h5>
          <div id="scroll_on_add_ons_in_item_detail_page" key={`complementary-items`} className={`${styleClasses.dressing_items_scrollbar}`}>
            <div className={`${styleClasses.items_inner_wrap}  d-flex items__inner_wrap`}>
              {ingredients.map((ingredient, i) => {
                const selectedSide = selectedIngredient(ingredient);
                return (
                  <div key={i} className={`${items_count} mb-4 me-3 complimentry__items_wrap`}>
                    {counterCard(ingredient, selectedSide)}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <Col lg= "7" className= {`${FullSize} Complimentary_sides-view px-0 px-md-0`}>
          <h5
            className={`${
              compli_title_size ? compli_title_size : 'f-s30 f-sm-s18'
            } large_text text-start mb-sm-3  pt-md-2`}
          >
            {title}
          </h5>
          <Row className={`${styleClasses.dressing_items_scrollbar} ${styleClasses.items_inner_wrap} mb-3 flex-nowrap`}>
            {ingredients.map((ingredient, i) => {
              const selectedSide = selectedIngredient(ingredient);
              return (
                <div className={`${items_count} mb-4 complimentry__items_wrap px-md-1`} key={ingredient?.id}>
                  {counterCard(ingredient, selectedSide)}
                </div>
              );
            })}
          </Row>
        </Col>
      )}
    </>
  );
};

export default AddOns;
